const enum BackgroundColourEnum {
  Black = 'black',
  Grey = 'grey',
  OffWhite = 'off-white',
  ShadowGrey = 'shadow-grey',
  Yellow = 'yellow',
}

export default BackgroundColourEnum;
